module.exports = __webpack_public_path__ + "static/media/food.5d6451b4.svg";